<template lang="pug">
  v-dialog(v-model='dialog', persistent, max-width='600px')
    v-card
      v-toolbar(dark, color='primary')
        v-btn(icon, dark, @click='close')
          v-icon close
        v-toolbar-title New Feedback
        v-spacer
        v-toolbar-items
          v-btn(v-if="favorite.favorite" @click="favoriteStatusChange()" flat icon color="red")
            v-icon(large) favorite
          v-btn(v-else large flat icon color="gray" @click="favoriteStatusChange()")
            v-icon favorite_border
          
      v-card-text
        v-container(grid-list-md)
          v-layout(wrap)
            v-flex(xs12, sm6)
              v-text-field(autofocus v-model="favorite.contactName" :error-messages="ContactNameErrors" label='Contact Person*', required)
            v-flex(xs12, sm6)
              v-autocomplete(v-model="favorite.position" :error-messages="PositionErrors" :items="['Owner', 'Supervisor', 'Manager', 'Employee']", label='Position')
            v-flex(xs12, sm6)
              v-combobox(clearable v-model="favorite.phoneNumber" :error-messages="PhoneNumberErrors" :items="phoneNumberList", label='Phone Number*')
            v-flex(xs12 sm6)
              div Rate The Call
              v-rating(v-model="favorite.rating" :error-messages="RatingErrors" dense half-increments hover )
            v-flex(xs12)
              v-textarea(v-model="favorite.talkAbout" :error-messages="TalkAboutErrors" label='Talk About*', required)
        small(color="red") *indicates required field
      v-card-actions
        v-spacer
        v-btn(color='blue darken-1', flat, @click='close') Close
        v-btn(color='blue darken-1' dark @click='save') Save
</template>

<script>
import feedbackService from '../service.js'
import { mapGetters } from 'vuex';
const { validationMixin } = require('vuelidate')
const {
  required,
  minLength,
} = require('vuelidate/lib/validators')

export default {
  props: {
    createDialog: {
      default: false
    },
    location: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      phoneNumberList: [],
      favorite : {
        favorite: false,
        rating: 0,
        contactName: null,
        phoneNumber: null,
        talkAbout: null,
        position: null,
      }
    }
  },
  mixins: [validationMixin],
  validations: {
    favorite: {
      rating: {
        required,
      },
      contactName: {
        required,
        minLength: minLength(2),
      },
      phoneNumber: {
        required,
        minLength: minLength(10),
      },
      talkAbout: {
        required,
        minLength: minLength(4),
      },
      position: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters('global', ['currentUser']),
    RatingErrors() {
      const errors = []
      if (!this.$v.favorite.rating.$dirty) return errors
      if (!this.$v.favorite.rating.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    ContactNameErrors() {
      const errors = []
      if (!this.$v.favorite.contactName.$dirty) return errors
      if (!this.$v.favorite.contactName.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.favorite.contactName.minLength) errors.push(this.$t('validations.fieldMustbeatLeast2ChrLong'))
      return errors
    },
    PhoneNumberErrors() {
      const errors = []
      if (!this.$v.favorite.phoneNumber.$dirty) return errors
      if (!this.$v.favorite.phoneNumber.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.favorite.phoneNumber.minLength) errors.push('Field Must be Atleast 10 numbers')
      return errors
    },
    PositionErrors() {
      const errors = []
      if (!this.$v.favorite.position.$dirty) return errors
      if (!this.$v.favorite.position.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    TalkAboutErrors() {
      const errors = []
      if (!this.$v.favorite.talkAbout.$dirty) return errors
      if (!this.$v.favorite.talkAbout.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.favorite.talkAbout.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
  },
  watch: {
    createDialog(val) {
      this.dialog = val
      if (val) {
        if (this.location) {
          this.phoneNumberList.push(this.location.businessPhone)
          if (this.location.cellPhone) this.phoneNumberList.push(this.location.cellPhone)
        }
      }
    }
  },
  methods: {
    favoriteStatusChange() {      
      this.favorite.favorite = !this.favorite.favorite
    },
    empty() {
      let favorite = {
        favorite: false,
        rating: 0,
        contactName: null,
        phoneNumber: null,
        talkAbout: null,
        position: null,
      }
      this.favorite = favorite
    },
    close() {
      this.empty()
      this.$emit('close')
    },
    save() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          type: 'error',
          title: 'Invalid Input'
        })
      } else {
        this.$Progress.start()
        this.favorite.storeID = this.location.storeID   
        this.favorite.userID = this.currentUser.userID 
        return feedbackService  
        .create(this.favorite)
        .then((response) => {
          this.$Progress.finish()
          this.$emit('getList')
          this.close()
        })
      }
    }
  },
}
</script>

<style scoped>
</style>